export default "__VITE_PUBLIC_ASSET__7a2845a1__"